import {
  ChangeDetectionStrategy,
  Component
} from '@angular/core';
import { MediaComponent, MediaService } from '@spartacus/storefront';

@Component({
  selector: 'app-media',
  templateUrl: './custom-media.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class CustomMediaComponent extends MediaComponent {

  constructor(
    protected mediaService: MediaService
  ) {
    super(mediaService);
  }

}
